import BrowsingHeader from './BrowsingHeader';

export default BrowsingHeader;
